import { PPP21_SECOND_DRAW } from '../forgiveness-summary-tile-constants';

export function loanVersionTag(messageParts, loanVersion) {
  const loanVersionString = loanVersion === PPP21_SECOND_DRAW ? 'Second Draw' : 'First Draw';

  return `${messageParts[0]}${loanVersionString}${messageParts[1]}`;
}
